// TeamIntegrationsContainer.js - Single source of truth for both team and subteam integrations
import React from 'react';
import TeamIntegrationsLayout from 'team/components/integrations/TeamIntegrationsLayout';
import { useIntegrations } from 'team/hooks/useIntegrations';

/**
 * Unified integrations container for both team-level and subteam-level integrations
 * @param {Object} props
 * @param {string} props.subteamId - Optional subteam ID. If provided, shows subteam integrations; otherwise shows team integrations
 * @param {Object} props.user - User object (optional, for future use)
 * @param {Object} props.team - Team object (optional, for future use)
 */
const TeamIntegrationsContainer = ({ subteamId = null, user = null, team = null }) => {
    const {
        searchTerm,
        availableIntegrations,
        connectedIntegrations,
        loading,
        selectedIntegration,
        connectionModalOpen,
        connecting,
        notification,
        handleSearchChange,
        handleIntegrationClick,
        handleConnectConfirm,
        handleDisconnect,
        handleConnectionModalClose,
        handleNotificationClose,
        isIntegrationConnected,
        getConnectionStatus,
        fetchIntegrations
    } = useIntegrations(subteamId, team);

    return (
        <TeamIntegrationsLayout
            searchTerm={searchTerm}
            subteamId={subteamId}
            availableIntegrations={availableIntegrations}
            connectedIntegrations={connectedIntegrations}
            loading={loading}
            connectionModalOpen={connectionModalOpen}
            selectedIntegration={selectedIntegration}
            connecting={connecting}
            notification={notification}
            onRefresh={fetchIntegrations}
            onSearchChange={handleSearchChange}
            onIntegrationClick={handleIntegrationClick}
            onDisconnect={handleDisconnect}
            onConnectConfirm={handleConnectConfirm}
            onConnectionModalClose={handleConnectionModalClose}
            onNotificationClose={handleNotificationClose}
            isIntegrationConnected={isIntegrationConnected}
            getConnectionStatus={getConnectionStatus}
        />
    );
};

export default TeamIntegrationsContainer;
